interface Props {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  children?: React.ReactNode;
}

export default function PageHeader({ icon, title, description, children }: Props) {
  return (
    <header className="flex flex-wrap items-start justify-between gap-4">
      <div className="flex items-start gap-3">
        {icon && <span className="mt-0.5 text-ui-accent shrink-0">{icon}</span>}
        <div>
          <h1 className="text-xl font-semibold text-ui-text">{title}</h1>
          {description && <p className="mt-0.5 text-sm text-ui-text-muted">{description}</p>}
        </div>
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </header>
  );
}
